module.exports = __webpack_public_path__ + "img/zhengtai.ac8b095a.png";